<div class="scrollable">
    <app-detail-display-document-list [fileIds]="fileIds"
        [dataType]="dataTypeEnum.PRODUCT"></app-detail-display-document-list>
</div>